import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LocalStorage } from '../local-storage.class';

@Injectable({
    providedIn: 'root',
})
export class LoggerService {
    constructor(private http: HttpClient) {}

    logError(error) {
        this.sendData(error, LocalStorage.version ?? 'unknown');
    }

    private sendData(error, versionInfo?: any) {
        try {
            this.http
                .post(`${environment.apiEndpoint}logging/app`, {
                    app_version: versionInfo,
                    exception: error,
                    url: window?.location?.href,
                })
                .pipe(
                    catchError(() => {
                        return of([]);
                    })
                )
                .subscribe();
        } catch (e) {}
    }
}
